import { SecureStorage } from '@aparajita/capacitor-secure-storage';
import type { TokenStorage } from '../api/auth.ts';

// Refresh token in the iOS Keychain / Android Keystore instead of WebView storage
// (ADR-0011). The auth store reads synchronously, so the value is cached in memory
// and loaded once before the session is restored.

const KEY = 'ste.refreshToken';

export async function loadSecureTokenStorage(): Promise<TokenStorage> {
  let cached: string | null = null;
  try {
    cached = await SecureStorage.getItem(KEY);
  } catch {
    cached = null;
  }
  return {
    get: () => cached,
    set: (token) => {
      cached = token;
      const write = token ? SecureStorage.setItem(KEY, token) : SecureStorage.removeItem(KEY);
      void write.catch(() => undefined);
    },
  };
}

export async function readSecure(key: string): Promise<string | null> {
  return SecureStorage.getItem(key).catch(() => null);
}

export async function writeSecure(key: string, value: string | null): Promise<void> {
  await (value ? SecureStorage.setItem(key, value) : SecureStorage.removeItem(key)).catch(() => undefined);
}
